import "./App.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ChakraProvider } from "@chakra-ui/react";
import Layout from "./components/defaultStructure/Layout";
import Signin from "./components/pages/login/Signin.js";
import ConvertToDeal from "./components/pages/crm/lead/leaddetail/ConvertToDeal.js";
import "react-toastify/dist/ReactToastify.css";
import { getUserList } from "./components/redux/utilsReduxApi/getUserList.js";
import { getDealList } from "./components/redux/utilsReduxApi/getDealList.js";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getVendorList } from "./components/redux/utilsReduxApi/getVendorList.js";
import { getClientList } from "./components/redux/utilsReduxApi/getClientList.js";
import { getCompanyList } from "./components/redux/utilsReduxApi/getCompanyList.js";
import { getLocationList } from "./components/redux/utilsReduxApi/getLocationList.js";
import { getSiteList } from "./components/redux/utilsReduxApi/getSiteList.js";
import { getProposalList } from "./components/redux/utilsReduxApi/getProposalList.js";
import { getWalkthroughList } from "./components/redux/utilsReduxApi/getWalkthrough.js";
import { getInventoryLookup } from "./components/redux/utilsReduxApi/getInventoryLookup.js";
import { getRoleLookup } from "./components/redux/utilsReduxApi/getRole.js";
import { getDepartmentList } from "./components/redux/utilsReduxApi/getDepartmentList.js";
import ForgotPassword from "./components/pages/login/ForgotPassword.js";
import OtpPage from "./components/pages/login/OtpPage.js";
import { getBrandListLookup, getSolarListLookup } from "./components/redux/utilsReduxApi/getBrandSolarlist.js";
import { getInverterLookup } from "./components/redux/utilsReduxApi/InverterLookup.js";
import { getPriceList } from "./components/redux/utilsReduxApi/getPriceList.js";
import { getInventorySolarPanelLookUp } from "./components/redux/utilsReduxApi/getInventorySolarPanelLookUp.js";
import ProtectedRoute from "./ProtectedRoute.js";
import PublicRoute from "./PubliceRoute.js";
import { Navigate } from "react-router-dom";
import { onMessage } from "firebase/messaging";
import { getMessaging } from "firebase/messaging";
import firebaseApp from "./components/Notification/FirebaseMessagingConfig.js";
import { refreshToken } from "./components/redux/api/auth/authApi.js";
  import { setFilteredStatus } from "./components/redux/reduxSlice/LeadSlice";
  import { getRolesLookUp } from "./components/redux/utilsReduxApi/getRolesLookUp.js";

function App() {
  window.onload = () => {
    sessionStorage.clear();
    setFilteredStatus(false)
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserList());
    dispatch(getDealList());
    dispatch(getVendorList());
    dispatch(getClientList());
    dispatch(getCompanyList());
    dispatch(getLocationList());
    dispatch(getSiteList());
    dispatch(getProposalList());
    dispatch(getWalkthroughList());
    dispatch(getInventoryLookup());
    dispatch(getRoleLookup());
    dispatch(getDepartmentList());
    dispatch(getBrandListLookup());
    dispatch(getSolarListLookup());
    dispatch(getInverterLookup());
    dispatch(getPriceList());
    dispatch(getInventorySolarPanelLookUp());
    dispatch(getRolesLookUp());
  }, [dispatch]);
  const messaging = getMessaging(firebaseApp);
  // Safe Notification API usage
  function showNotification(title, options) {
    if (typeof window !== "undefined" && "Notification" in window) {
      if (Notification.permission === "granted") {
        new Notification(title, options);
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            new Notification(title, options);
          }
        });
      }
      // If denied, do nothing
    }
    // If Notification not supported, do nothing
  }

  useEffect(() => {
    const isWebView = /wv/.test(navigator.userAgent) || !!window.AndroidInterface;

    if (isWebView) {
      console.log("📱 WebView detected — skipping Notification API logic");
      return;
    }

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Foreground message received:", payload);

      const title = payload?.notification?.title || "🔔 New Notification!";
      const options = {
        body: payload?.notification?.body || "You have a new message.",
        icon: "/Solar_logo.webp",
        badge: "/badge-icon.png",
        vibrate: [200, 100, 200],
        data: {
          url: "https://numberdar-solar-60038016672.development.catalystserverless.in/app/index.html",
        },
      };
      // Show notification using the safe function
      showNotification(title, options);

      if (typeof window !== "undefined" && "Notification" in window) {
        if (Notification.permission === "granted") {
          const n = new Notification(title, options);

          n.onclick = (e) => {
            e.preventDefault();
            window.open(options.data.url, "_blank");
          };

          setTimeout(() => {
            n.close();
          }, 4000);
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
              new Notification(title, options);
            }
          });
        }
      } else {
        console.warn("❌ Notification API not supported in this environment.");
      }
    });

    return () => unsubscribe();
  }, []);

  // useEffect(() => {
  //   refreshToken();
  // }, []);

  return (
    <>
      <div className="App">
        <ToastContainer position="top-left" autoClose={2500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
        <ChakraProvider>
          <HashRouter>
            <Routes>
              <Route
                path="*"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/"
                element={
                  <PublicRoute>
                    <Signin />
                  </PublicRoute>
                }
              />
              <Route
                path="/otp-page"
                element={
                  <PublicRoute>
                    <OtpPage />
                  </PublicRoute>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <PublicRoute>
                    <ForgotPassword />
                  </PublicRoute>
                }
              />

              <Route
                path="/convert-to-deal"
                element={
                  <ProtectedRoute>
                    <ConvertToDeal />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </HashRouter>
        </ChakraProvider>
      </div>
    </>
  );
}
export default App;
